const reducer = (state, action) => {
  switch (action.type) {
    case 'newPaymentModalOpen':
      return {
        ...state,
        newPaymentModalOpen: action.newPaymentModalOpen,
      }
    case 'toggleRoyaltyPaymentModal':
      return {
        ...state,
        royaltyModalOpen: action.royaltyModalOpen,
      }
    case 'toggleCommissionPaymentModal':
      return {
        ...state,
        commissionModalOpen: action.commissionModalOpen,
      }
    case 'updateNewPaymentDescription':
      return {
        ...state,
        newPaymentDescription: action.newPaymentDescription,
      }
    case 'updateNewPaymentAmount':
      return {
        ...state,
        newPaymentAmount: action.newPaymentAmount,
      }
    case 'updateNewPaymentTransactionID':
      return {
        ...state,
        newPaymentTransactionID: action.newPaymentTransactionID,
      }
    case 'updateNewPaymentCoursenum':
      return {
        ...state,
        newPaymentCoursenum: action.newPaymentCoursenum,
      }
    case 'updateRoyaltiesOwed':
      return {
        ...state,
        royaltiesOwed: action.royaltiesOwed,
      }
    case 'updateNewSource':
      return {
        ...state,
        newSource: action.newSource,
      }
    case 'updateNewInvoiceNumber':
      return {
        ...state,
        newInvoiceNumber: action.newInvoiceNumber,
      }
    case 'updateCommissions':
      return {
        ...state,
        commissions: action.commissions,
      }
    case 'updatePaymentItemId':
      return {
        ...state,
        paymentItemID: action.paymentItemId,
      }
    case 'updateSalespeople':
      return {
        ...state,
        salespeople: action.salespeople,
      }
    case 'resetFormData':
      return {
        ...state,
        newPaymentAmount: '',
        newPaymentTransactionID: '',
        newPaymentCoursenum: '',
      }
  }
}

export default reducer
